module.exports = __webpack_public_path__ + "img/050-file.d9433697.png";